import { exctractSubdomain } from './generate-url';

const getEnvironment = (url: string) => {
  const segments = url.split('.');
  const insightsSegment = segments.filter((value) => value.includes('insights'))[0];

  if (!insightsSegment.includes('-')) {
    return 'production';
  }

  return insightsSegment.split('-')[0];
};

const getCookieDomain = (url: string) => {
  console.log('url', url);
  return url.split('.').slice(-2).toString().replace(',', '.');
};

export const setJotformCookies = () => {
  const origin = window.location.origin;

  const domain = getCookieDomain(origin);
  const environment = getEnvironment(origin);
  const realm = exctractSubdomain();

  document.cookie = `restoreRealm=${realm};domain=${domain};SameSite=None; Secure`;
  document.cookie = `restoreEnv=${environment};domain=${domain};SameSite=None; Secure`;
};
